import { render, staticRenderFns } from "./WikidataTags.vue?vue&type=template&id=cb65321a&"
import script from "./WikidataTags.vue?vue&type=script&lang=js&"
export * from "./WikidataTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports